import { API } from "aws-amplify";
import {
  extractClaimedAtFromEvents,
  MAX_INDEX_PAGES_PER_ACTION,
  searchFinishedSessionsForAlias,
} from "./sessionHistoryUtils";

export const SESSION_HISTORY_PAGE_LIMIT = 50;
const HISTORY_PAGE_LIMIT = 50;
const HISTORY_MAX_PAGES = 10;

export const FINISHED_STATUS_FILTER = {
  status: {
    eq: "FINISHED",
  },
};

export const FinishedPodSessionsByProctor = /* GraphQL */ `
  query FinishedPodSessionsByProctor(
    $proctor: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPodSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    podSessionByProctor(
      proctor: $proctor
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        proctor
        testerName
        organizationId
        createdAt
        createdAtCentralDate
        status
        notes
        googleMeetLink
      }
    }
  }
`;

export const PodSessionHistoriesBySessionId = /* GraphQL */ `
  query PodSessionHistoriesBySessionId(
    $id: ID
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    listPodSessionHistories(
      id: $id
      timestamp: $timestamp
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        id
        timestamp
        input
      }
    }
  }
`;

export async function fetchFinishedSessionsPage(proctor, nextToken) {
  const { data } = await API.graphql({
    query: FinishedPodSessionsByProctor,
    variables: {
      proctor,
      sortDirection: "DESC",
      filter: FINISHED_STATUS_FILTER,
      limit: SESSION_HISTORY_PAGE_LIMIT,
      nextToken: nextToken || undefined,
    },
  });

  const connection = data?.podSessionByProctor;

  return {
    items: Array.isArray(connection?.items) ? connection.items : [],
    nextToken: connection?.nextToken ?? null,
  };
}

export async function fetchFinishedSessionsUntilFound(
  proctor,
  startToken,
  { onSkippedEmptyPage } = {},
) {
  return searchFinishedSessionsForAlias({
    startToken,
    maxPages: MAX_INDEX_PAGES_PER_ACTION,
    onSkippedEmptyPage,
    fetchPage: (token) => fetchFinishedSessionsPage(proctor, token),
  });
}

export async function fetchClaimedAtTimestamp(podSessionId, finalProctor) {
  if (!podSessionId) {
    return null;
  }

  let nextToken = null;
  let page = 0;
  const events = [];

  do {
    const { data } = await API.graphql({
      query: PodSessionHistoriesBySessionId,
      variables: {
        id: podSessionId,
        sortDirection: "DESC",
        limit: HISTORY_PAGE_LIMIT,
        nextToken: nextToken || undefined,
      },
    });

    const connection = data?.listPodSessionHistories;
    events.push(...(connection?.items ?? []));

    const claimedAt = extractClaimedAtFromEvents(events, finalProctor);
    if (claimedAt) {
      return claimedAt;
    }

    nextToken = connection?.nextToken ?? null;
    page += 1;
  } while (nextToken && page < HISTORY_MAX_PAGES);

  return null;
}
